import { Flame, Sparkles, MapPin } from "lucide-react";

const FEATURES = [
  {
    icon: Sparkles,
    title: "Crispy Every Time",
    desc: "Hand-tossed, double-coated, perfected over hundreds of drops. That bite? It's engineered.",
  },
  {
    icon: Flame,
    title: "Freshly Cooked",
    desc: "We don't reheat. Every batch hits the oil only when your order lands.",
  },
  {
    icon: MapPin,
    title: "South East Favourite",
    desc: "Born in New Zealand, built for the South East.",
  },
];

export default function WhyLove() {
  return (
    <section
      id="why"
      data-testid="why-section"
      className="relative py-20 md:py-28 overflow-hidden"
    >
      <div className="absolute inset-0 bg-[#171D4F]" />
      <div className="absolute -top-32 left-1/2 -translate-x-1/2 w-[900px] h-[900px] rounded-full bg-[radial-gradient(circle,rgba(237,11,9,0.18),rgba(23,29,79,0)_60%)] blur-2xl" />

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-2xl">
          <div className="text-xs uppercase tracking-[0.3em] text-[#F4A623]">Why people lose it</div>
          <h2 className="font-display mt-3 text-4xl sm:text-5xl lg:text-6xl uppercase tracking-tight text-[#F6F0E8]">
            Why people <span className="text-[#ED0B09] text-glow-red">love</span> Gullway
          </h2>
        </div>

        <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 lg:gap-6">
          {FEATURES.map((f, i) => {
            const Icon = f.icon;
            return (
              <div
                key={f.title}
                data-testid={`why-card-${i}`}
                className="group relative bg-[#0A0D26]/60 backdrop-blur-md border border-[#F6F0E8]/10 rounded-3xl p-7 transition-all duration-500 hover:-translate-y-1.5 hover:border-[#F4A623]/50 hover:shadow-[0_20px_50px_rgba(244,166,35,0.18)]"
              >
                <div className="relative h-14 w-14 rounded-2xl bg-gradient-to-br from-[#ED0B09] to-[#B42A27] flex items-center justify-center shadow-[0_10px_30px_rgba(237,11,9,0.45)]">
                  <Icon className="text-[#F6F0E8]" size={24} />
                </div>
                <h3 className="mt-5 font-display text-2xl uppercase text-[#F6F0E8] leading-tight">
                  {f.title}
                </h3>
                <p className="mt-2 text-sm text-[#F6F0E8]/70 leading-relaxed">{f.desc}</p>
                <div className="absolute right-6 top-6 text-[#F6F0E8]/20 font-display text-3xl">
                  0{i + 1}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
